import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, filter, first, take } from 'rxjs';
import { LgvClientService, NotificationService } from '../../core/core.module';
import { LgvLoanApplicationService } from '../../core/services/lgv-loan-application.service';
import { LgvLoanApp } from '../../data-models/lgv-loan-application.model';
import { LgvModel } from '../../data-models/longevity.model';
import { LoanAppTaskModalComponent } from '../loan-app-task-modal/loan-app-task-modal.component';

@Component({
    selector: 'lgv-add-doc-to-task-modal',
    templateUrl: './add-doc-to-task-modal.component.html',
    styleUrls: ['./add-doc-to-task-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddDocToTaskModalComponent implements OnInit {

    dataParam: any;
    selectedClient: LgvModel.ClientDTO;

    isLoadingLoans$ = new BehaviorSubject(false);
    isLoadingLoanDetail$ = new BehaviorSubject(false);

    _clientLoans: LgvLoanApp.LoanApplicationSummary[] = null;
    clientLoans$ = new BehaviorSubject(this._clientLoans);
    selectedLoan:LgvLoanApp.LoanApplicationSummary;

    _tasks: LgvLoanApp.Task[] = null;
    tasks$ = new BehaviorSubject(this._tasks);
    selectedTask:LgvLoanApp.Task;

    _selectedLoanDetails: LgvLoanApp.LoanApplicationDetail = null;
    selectedLoanDetails$ = new BehaviorSubject(this._selectedLoanDetails);

    get readyToSubmit():boolean {return !!this.selectClient && !!this.selectedLoan && !!this.selectedTask}

    constructor(private lgvClientSvc:LgvClientService,
        private lgvLoanAppSvc: LgvLoanApplicationService,
        private notificationSvc: NotificationService,
        public matDialog: MatDialog,
        public dialogRef: MatDialogRef<AddDocToTaskModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.dataParam = data;
    }

    ngOnInit(): void {
    }

    onSubmit() {
        this.lgvLoanAppSvc.linkEmailAttachmentToTask(this.dataParam.selectedAgentId, this.selectedLoan.id, this.selectedTask.id, this.dataParam.email.id, this.dataParam.emailAttachment.id).pipe(take(1)).subscribe(x=>{
            this.dialogRef.close({ action: true });
            this.notificationSvc.success(`Document linked to task - ${this.selectedTask.name}`);
        },
        (err: Error) => {
            this.isLoadingLoans$.next(false);
            const msg = 'There was an error fetching client loans';
            this.notificationSvc.error(msg);
            console.log(msg);
        }
    );

    }

    onCancel() {
        this.dialogRef.close({ action: false });
    }

    selectClient(client: LgvModel.ClientDTO) {
        this.selectedClient = client;
        this.fetchClientLoans();

        this.clientLoans$.next(null);
        this.selectedLoan = null;
        this.tasks$.next(null);
        this.selectedTask = null;
    }

    fetchClientLoans(){
        this.isLoadingLoans$.next(true);

        this.lgvLoanAppSvc.fetchLoanApplications(this.selectedClient.id).pipe(filter(f=>!!f), take(1), ).subscribe(x=>{
                this.isLoadingLoans$.next(false);

                if(x.value){
                    this.clientLoans$.next(x.value);
                }
        },
            (err: Error) => {
                this.isLoadingLoans$.next(false);
                const msg = 'There was an error fetching client loans';
                console.log(msg);
                this.notificationSvc.error(msg);
            }
        );

    }

    onLoanSelected(loan: LgvLoanApp.LoanApplicationSummary){
        this.tasks$.next(null);
        this.selectedTask = null;
        this.isLoadingLoanDetail$.next(true);

        this.lgvLoanAppSvc.fetchThisLoanApp(this.selectedLoan.id, this.selectedClient.id).pipe(filter(f=> !!f), take(1)).subscribe(loanApp=>{
            this.tasks$.next(loanApp.tasks);
            this.isLoadingLoanDetail$.next(false);
        },
        (err: Error) => {
            this.isLoadingLoanDetail$.next(false);
            const msg = 'There was an error fetching the loan details';
            console.log(msg);
            this.notificationSvc.error(msg);
        });
    }

    openTaskModal() {
        const dialogRef = this.matDialog.open(LoanAppTaskModalComponent, {
            width: '800px',
            panelClass: 'dialog-container',
            //disableClose: true,
            data: {
                clientId: this.dataParam.clientId,
                agentDTO: this.dataParam.agentDTO,
                loanAppId: this.selectedLoan.id,
                mode: 'addTask',
                isReturnOnly: false
            }
        });

        dialogRef.afterClosed().pipe(first()).subscribe(dialogResponse => {
            if (dialogResponse?.action === true) {
                if (dialogResponse?.task) {

                    let tempTasks = this.tasks$.value;
                    tempTasks.push(dialogResponse.task);
                    this.tasks$.next(tempTasks);

                    this.selectedTask = dialogResponse.task;
                }
            }
        });

    }

}
